exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stepCopy___2UAKx {\n  font-size: 20px;\n  line-height: 32px;\n  font-weight: 400;\n  color: #505050;\n}\n@media (max-width: 991px) {\n  .hideSm___hOUOH {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  #react-joyride-step-0 .__floater.__floater__open {\n    transform: none !important;\n    left: 0 !important;\n    top: unset !important;\n    bottom: 0;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"stepCopy": "stepCopy___2UAKx",
	"hideSm": "hideSm___hOUOH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/guestlist/addressCollection/ManageAddressCollectionLinkTour/ManageAddressCollectionLinkTour.module.less
// module id = 2363
// module chunks = 71